module.exports = __webpack_public_path__ + "static/smiling_woman_ipad-711184e944df7f0e7c0465363919b2df.jpg";